import type { ApmBase, Transaction } from "@elastic/apm-rum";

/**
 *
 *
 */
export type NoOps = [noopNull: () => null, noopUndefined: () => undefined];

/**
 *
 *
 */
export const noops: NoOps = [() => null, () => undefined];

/**
 *
 *
 *
 *
 *
 */
export const withTransaction =
  <R, A extends unknown[]>(
    agent: ApmBase,
    withCb: (transaction: Transaction, ...args: NoInfer<A>) => R,
  ): ((...args: A) => R) =>
  (...a) => {
    const transaction = agent.getCurrentTransaction();
    return transaction ? withCb(transaction, ...a) : (undefined as R);
  };
